"use client";

import { useEffect } from "react";

export default function SuppressKnownWarnings() {
    useEffect(() => {
        if (process.env.NODE_ENV !== "development") return;
        const original = console.error;
        const noisy = "Encountered a script tag while rendering React component";
        console.error = (...args: unknown[]) => {
            const first = args[0];
            if (typeof first === "string" && first.includes(noisy)) return;
            original.apply(console, args as Parameters<typeof console.error>);
        };
        return () => {
            console.error = original;
        };
    }, []);
    return null;
}
